// import images from "../../images/a2.png";
// import images from "../../images/a3.png";
// import images from "../../images/a1.jpg";
// import images from "../../images/a3.jpg";

// export const portfolioData = [
//   {
//     sectionId: 2,
//     projectName: "ToDo Application",
//     projectLink: "",
//     image: images,
//   },
//   {
//     sectionId: 2,
//     projectName: "ToDo Application",
//     projectLink: "",
//     image: images,
//   },
//   {
//     sectionId: 2,
//     projectName: "ToDo Application",
//     projectLink: "",
//     image: images,
//   },
//   {
//     sectionId: 2,
//     projectName: "ToDo Application",
//     projectLink: "",
//     image: images,
//   },
//   {
//     sectionId: 2,
//     projectName: "ToDo Application",
//     projectLink: "",
//     image: images,
//   },
// ];

// export const filterOptions = [
//   {
//     lable: "הכל",
//     id: 1,
//   },
//   {
//     lable: "פיתוח",
//     id: 2,
//   },
//   {
//     lable: "עיצוב",
//     id: 3,
//   },
// ];

import ImageOne from "../../images/image1.jpg";
import ImageTwo from "../../images/image2.jpg";
import ImageThree from "../../images/image3.jpg";
import ImageFour from "../../images/image4.jpg";
import ImageFive from "../../images/image5.jpg";

export const portfolioData = [
  {
    sectionId: 2,
    projectName: "בקרוב",
    projectLink: "", //project link here based on you choice
    image: ImageOne,
  },
  {
    sectionId: 2,
    projectName: "בקרוב",
    projectLink: "", //project link here based on you choice
    image: ImageTwo,
  },
  {
    sectionId: 2,
    projectName: "בקרוב",
    projectLink: "", //project link here based on you choice
    image: ImageThree,
  },
  {
    sectionId: 3,
    projectName: "בקרוב",
    projectLink: "", //project link here based on you choice
    image: ImageFour,
  },
  {
    sectionId: 3,
    projectName: "בקרוב",
    projectLink: "", //project link here based on you choice
    image: ImageFive,
  },
];

export const filterOptions = [
  {
    label: "הכל",
    id: 1,
  },
  {
    label: "פיתוח",
    id: 2,
  },
  {
    label: "עיצוב",
    id: 3,
  },
];
